// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const blogs = [
//   {
//     img: "/images/keyword/1.jpg",
//     title: "Corporate cab service in pune",
//     description:
//       "Experience seamless mobility with our Corporate Cab Service in Pune. Professional, reliable, and cost-effective travel solutions designed for both daily office commutes and business assignments.",
//     link: "corporate-cab-service-in-pune",
//   },
//   {
//     img: "/images/keyword/120.jpg",
//     title: "Monthly Cab Services in Pune",
//     description:
//       "Enjoy stress-free commuting with our Monthly Cab Services in Pune. Affordable, timely, and comfortable travel options perfect for regular office travel and long-term corporate needs.",
//     link: "Monthly-Cab-Services-in-Pune",
//   },
//   {
//     img: "/images/keyword/61.jpg",
//     title: "Corporate Cab Services in Bangalore",
//     description:
//       "Experience smooth and reliable travel with our Corporate Cab Services in Bangalore. Cost-effective, punctual, and comfortable solutions ideal for daily employee commutes and business travel needs.",
//     link: "Corporate-Cab-Services-in-Bangalore",
//   },

// ];

// const BlogSection = () => {
//   const settings = {
//     dots: false,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     speed: 800,
//     arrows: false,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 1 } },
//     ],
//   };

//   return (
//     <section className="blog-section">
//       <div className="container">
//         <div className="section-title text-center">
//           <span className="sub-title">Pune Corporate Cars India Private Limited</span>
//           <h2 className="title">Our Blogs</h2>
//         </div>

//         <Slider {...settings}>
//           {blogs.map((blog, index) => (
//             <div key={index} className="blog-card">
//               <div className="blog-img-box">
//                 <img src={blog.img} alt={blog.title} className="blog-img" />
//               </div>
//               <div className="blog-content">
//                 <span className="badge">Pune Corporate Cars India Private Limited</span>
//                 <h4>{blog.title}</h4>
//                 <p>{blog.description}</p>
//                 <a href={blog.link} className="read-more">
//                   Read More →
//                 </a>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default BlogSection;







import React from "react";

const blogs = [
  {
    img: "/images/keyword/1.jpg",
    title: "Corporate cab service in pune",
    description:
      "Experience seamless mobility with our Corporate Cab Service in Pune. Professional, reliable, and cost-effective travel solutions designed for both daily office commutes and business assignments.",
    link: "corporate-cab-service-in-pune",
  },
  {
    img: "/images/keyword/120.jpg",
    title: "Monthly Cab Services in Pune",
    description:
      "Enjoy stress-free commuting with our Monthly Cab Services in Pune. Affordable, timely, and comfortable travel options perfect for regular office travel and long-term corporate needs.",
    link: "Monthly-Cab-Services-in-Pune",
  },
  {
    img: "/images/keyword/61.jpg",
    title: "Corporate Cab Services in Bangalore",
    description:
      "Experience smooth and reliable travel with our Corporate Cab Services in Bangalore. Cost-effective, punctual, and comfortable solutions ideal for daily employee commutes and business travel needs.",
    link: "Corporate-Cab-Services-in-Bangalore",
  },
];

const BlogSection = () => {
  return (
    <section className="blog-section">
      <div className="container">
        <div className="section-title text-center">
          <span className="sub-title">
            Pune Corporate Cars India Private Limited
          </span>
          <h2 className="title">Our Blogs</h2>
        </div>

        <div className="blog-grid">
          {blogs.map((blog, index) => (
            <div key={index} className="blog-card">
              <div className="blog-img-box">
                <img
                  src={blog.img}
                  alt={blog.title}
                  className="blog-img"
                />
              </div>
              <div className="blog-content">
                <span className="badge">
                  Pune Corporate Cars India Private Limited
                </span>
                <h4>{blog.title}</h4>
                <p>{blog.description}</p>
                <a href={blog.link} className="read-more">
                  Read More →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
